import { TenantContext } from '../realm-context';
import type { RealmAuthStore } from './store';

export function selectActiveAccess(state: RealmAuthStore) {
  return state.activeAccess;
}

export function selectContext(state: RealmAuthStore) {
  return state.context;
}

export function selectIsAuthenticating(state: RealmAuthStore) {
  return state.isAuthenticating;
}

export function selectIsAuthenticated(state: RealmAuthStore) {
  return state.isAuthenticated;
}

export function selectReset(state: RealmAuthStore) {
  return state.reset;
}

export function selectSetActiveAccess(state: RealmAuthStore) {
  return state.setActiveAccess;
}

export function selectSetContext(state: RealmAuthStore) {
  return state.setContext;
}

export function selectSetIsAuthenticating(state: RealmAuthStore) {
  return state.setIsAuthenticating;
}

export function selectSetIsAuthenticated(state: RealmAuthStore) {
  return state.setIsAuthenticated;
}

export function selectActiveOrganizationMembership(state: RealmAuthStore) {
  if (state.activeAccess?.tenant?.tenantType !== TenantContext.Organization) {
    return undefined;
  }

  return state.context?.organizationMemberships?.find(
    (membership) => membership.organization?.organizationId === state.activeAccess?.tenant?.tenantId,
  );
}
